export const SET_COURTS = 'SET_COURTS';
export const COURT_SENDING_REQUEST = 'COURT_SENDING_REQUEST';
export const COURT_SENDING_REQUEST_FAILURE = 'COURT_SENDING_REQUEST_FAILURE';
